import { ShieldCheck } from 'lucide-react'

import { AppraisalField } from '@/components/deals/appraisal/AppraisalField'
import { AppraisalSection } from '@/components/deals/appraisal/AppraisalSection'

const DEFAULT_STATE = {
  purchaseInterestRatePa: '',
  purchaseLtvPercent: '',
  purchaseBrokerFee: '',
  purchaseArrangementFeePercent: '',
  purchaseValuationFee: '',
  developmentInterestRatePa: '',
  developmentLtcPercent: '',
  developmentBrokerFee: '',
  developmentArrangementFeePercent: '',
  developmentValuationFee: '',
  refinanceInterestRatePa: '',
  refinanceLtvPercent: '',
  refinanceBrokerFee: '',
  refinanceArrangementFeePercent: '',
  refinanceValuationFee: '',
}

const FINANCE_COLUMNS = [
  {
    title: 'Purchase',
    fields: [
      { name: 'purchaseInterestRatePa', label: 'Annual Interest Rate', suffix: '%' },
      { name: 'purchaseLtvPercent', label: 'LTV', suffix: '%' },
      { name: 'purchaseBrokerFee', label: 'Broker Fee', prefix: '£' },
      { name: 'purchaseArrangementFeePercent', label: 'Arrangement Fee', suffix: '%' },
      { name: 'purchaseValuationFee', label: 'Valuation Fee', prefix: '£' },
    ],
  },
  {
    title: 'Development',
    fields: [
      { name: 'developmentInterestRatePa', label: 'Annual Interest Rate', suffix: '%' },
      { name: 'developmentLtcPercent', label: 'LTC', suffix: '%' },
      { name: 'developmentBrokerFee', label: 'Broker Fee', prefix: '£' },
      { name: 'developmentArrangementFeePercent', label: 'Arrangement Fee', suffix: '%' },
      { name: 'developmentValuationFee', label: 'Valuation Fee', prefix: '£' },
    ],
  },
  {
    title: 'Refinance',
    fields: [
      { name: 'refinanceInterestRatePa', label: 'Annual Interest Rate', suffix: '%' },
      { name: 'refinanceLtvPercent', label: 'LTV', suffix: '%' },
      { name: 'refinanceBrokerFee', label: 'Broker Fee', prefix: '£' },
      { name: 'refinanceArrangementFeePercent', label: 'Arrangement Fee', suffix: '%' },
      { name: 'refinanceValuationFee', label: 'Valuation Fee', prefix: '£' },
    ],
  },
]

export function FinanceStructurePanel({ state, onStateChange }) {
  const financeState = { ...DEFAULT_STATE, ...state }

  function updateField(field, value) {
    onStateChange?.({ ...financeState, [field]: value })
  }

  return (
    <AppraisalSection title="Finance Structure" icon={ShieldCheck}>
      <div className="grid gap-5 border-t border-border/50 pt-2 lg:grid-cols-3">
        {FINANCE_COLUMNS.map((column) => (
          <section key={column.title} className="space-y-4">
            <h3 className="border-b border-border/50 pb-2 text-[11px] font-bold uppercase tracking-widest text-foreground">
              {column.title}
            </h3>
            <div className="space-y-4">
              {column.fields.map((field) => (
                <AppraisalField
                  key={field.name}
                  label={field.label}
                  value={financeState[field.name]}
                  prefix={field.prefix}
                  suffix={field.suffix}
                  inputMode="decimal"
                  aria-label={`${column.title} ${field.label}`}
                  className="bg-muted/30 font-bold focus-visible:bg-background"
                  onChange={(event) => updateField(field.name, event.target.value)}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
    </AppraisalSection>
  )
}
